import { Injectable } from '@angular/core'
import { Router, NavigationStart, NavigationEnd } from '@angular/router'
import { filter } from 'rxjs/operators'

export interface INavigationState {
  id: string
  url: string
  name: string
}

/**
 * This service used to store previous view url and provide ability to go to previous page.
 * Also logic related to main menu items and routes moved here.
 *
 * Actual navigation logic on 'back' button click is here:
 * - edit center => go back
 * - add mission => go back
 * - edit user => go back
 *
 * - missions queue => dashboard
 * - preflight => dashboard
 * - users list => dashboard
 *
 * - edit route => routes view
 * - edit vehicle => vehicles view
 */
@Injectable()
export class NavigationService {
  defaultUrl = '/app/dashboard'
  currentUrl = this.defaultUrl
  previousUrl = this.defaultUrl
  currentRootStateName = 'Live Missions'

  /**
   * this array store objects used by top left navigation menu.
   * here we have id for selenium tests,
   * url for routerLink directive
   * and name to display on menu items in html
   */
  rootStates: INavigationState[] = [
    { id: 'dashboard', url: '/app/dashboard', name: 'Live Missions' },
    { id: 'package-queue', url: '/app/package-queue', name: 'Orders and Packages' },
  ]

  private storageId = 'previousUrl'

  constructor(private router: Router) {
    const maybeStorageUrl: string | null = localStorage.getItem(this.storageId)

    this.previousUrl = maybeStorageUrl ?? this.previousUrl

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      // store current url
      this.currentUrl = event.url

      // set current state name
      const foundState = this.rootStates.find((item) => item.url === event.url)
      this.currentRootStateName = foundState ? foundState.name : ''
    })

    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
      // store previous url
      this.previousUrl = this.currentUrl
      localStorage.setItem(this.storageId, this.previousUrl)
    })
  }

  goBack(): void {
    this.router.navigate([this.previousUrl])
  }
}
